import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Toggle from "../Components/Toggle";
import { Link, useNavigate } from "react-router-dom";
import Timecheck from "../Components/Timecheck";
import moment from "moment/moment";
import {
  checkAvailiablity,
  getSymtomsapi,
  patientBookapointment,
} from "../network/Network";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { GET_PHYSICIAN } from "../redux/Slices/AuthSlice";
import MyModal from "../Components/MyModal";
import StripeForm from "../Components/StripeForm";
import { mastercard, visapayment } from "../Constant/Index";
import Select from "react-select";

const BookAppointment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sitesetting = useSelector((state) => state?.Auth?.sitesetting);
  const [selectedHour, setSelectedHour] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [myday, setMyday] = useState("");
  const [date, setDate] = useState(new Date());
  const [selectedCard, setSelectedCard] = useState("");
  const [initialState, setInitialState] = useState(false);
  const [isOn, setIsOn] = useState(initialState);
  const [symptoms, setSymptoms] = useState([]);
  const [timeslots, setTimeSlots] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedSymptom, setSelectedSymptom] = useState("");
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);
  const [selectdetails, setSelectdetails] = useState("");
  const [formErrors, setFormErrors] = useState([]);
  const [checkStatuspage, setCheckStatuspage] = useState("false");
  const token = useSelector((state) => state?.Auth?.token);
  const physicianDetail = useSelector((state) => state?.Auth?.physician);
  const [loading, setLoading] = useState(false);

  const hours = [
    "08.00 PM",
    "08.30 PM",
    "09.00 PM",
    "09.30 AM",
    "10.00 AM",
    "10.30 AM",
    "11.00 AM",
    "11.30 AM",
    "12.00 AM",
  ];

  useEffect(() => {
    getStatus(date);
  }, []);

  function convertTo24Hour(time12h) {
    const [time, modifier] = time12h.split(" "); 
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:00`;
  }

  const getStatus = (filter_date) => {
    let array = [];
    if (!isNaN(filter_date)) {
      let slots = sitesetting?.time_slots;
      for (let i = 0; i < slots.length; i++) {
        const dateTime = new Date(
          `${filter_date?.toLocaleDateString("en-CA")}T${convertTo24Hour(
            slots[i].start_time
          )}`
        );
        array.push({
          slot: slots[i].slot,
          start_time: slots[i].start_time,
          status: dateTime > new Date(),
          selected: false,
        });
      }
      setTimeSlots(array);
    }
  };

  const handleHourClick = (hour) => {
    setSelectedHour(hour);
  };

  // Handle change when user selects a time
  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value);
  };
  // =======================

  const onChange = (newDate) => {
    const date = new Date(newDate);

    // Extracting the day (e.g., "Thu")
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "short" });
    setMyday(dayOfWeek);
    const formattedDate = newDate

      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-"); 
    setDate(formattedDate);
    getStatus(newDate);
  };

  const checkAvailiabity = (e) => {
    e.preventDefault();
    setLoading(true);

    // Ensure that 'myday' and 'date' are defined
    if (!myday || !date) {
      setLoading(false); 
      Swal.fire({
        position: "center",
        icon: "error",
        text: "Select both day and date",
        showConfirmButton: false,
        timer: 1500,
      });
      return; 
    }

    // Ensure that 'selectedTime' is defined
    if (!selectedHour) {
      setLoading(false); 
      Swal.fire({
        position: "center",
        icon: "error",
        text: "Kindly Select Time",
        showConfirmButton: false,
        timer: 1500,
      });
      return; 
    }

    // Proceed if all fields are valid
    let data = {
      booking_day: myday,
      booking_date: date,
      // booking_time: selectedTime,
      booking_time: selectedHour,
      // developmentMode: true,
    };

    // Call to check availability
    checkAvailiablity(data, token)
      .then((res) => {
        dispatch(GET_PHYSICIAN(res?.data?.physician));
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Physician is Availaible",
          showConfirmButton: false,
          timer: 3000,
        });
        setCheckStatuspage("true");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false); 
        Swal.fire({
          position: "center",
          icon: "error",
          text: err?.response?.data?.message || "An error occurred",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  // ======================
  const handleCardClick = (card) => {
    setSelectedCard(card);
  };
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Get Symptoms Api
  useEffect(() => {
    getSymtomsapi().then((res) => {
      setSymptoms(res?.data);
    });
  }, []);

  const formattedOptions = symptoms.map((item) => ({
    value: item?.id, 
    label: item?.title, 
  }));
  const handleSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : []; 
    setSelectedSymptoms(selectedValues); 
  };
  //   ================
  const PlaceholderHandler = (e, stripe_token) => {
    e.preventDefault();
    let isValid = true;
    const errors = {};

    if (!selectedSymptom) {
      Swal.fire({
        position: "center",
        icon: "success",
        text: "Congratulations!",
        showConfirmButton: false,
        timer: 1500,
      });
    }

    // Validate Email
    if (!selectdetails) {
      if (!errors || !errors.selectdetails) {
        if (!errors) errors = {};
        errors.selectdetails = [];
      }
      errors.selectdetails.push("Details is required");
      isValid = false;
    }

    setFormErrors(errors);
    setTimeout(() => {
      setFormErrors([]);
    }, 3000);
    let data = {
      booking_day: myday,
      booking_date: date,
      booking_time: selectedHour,
      symptom_ids: selectedSymptoms,
      detail: selectdetails,
      share_medical_reports: isOn,
      stripe_token: stripe_token,
      physician_id: physicianDetail?.id,
    };

    patientBookapointment(data, token)
      .then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Congratulations!",
          showConfirmButton: false,
          timer: 2000,
        });
        navigate("/my-consultations");
      })
      .catch((err) => {});
  };

  //   Stripe css
  const styling = {
    marginTop: "10px",
    width: "100%",
    padding: "8px 16px",
    borderRadius: "20px",
  };

  return (
    <>
      <Header />
      {checkStatuspage == "false" ? (
        <PageHeader pagename="Check Physcian Availaibility" />
      ) : (
        <PageHeader pagename="Book Appointment" />
      )}

      {checkStatuspage == "false" ? (
        <section className="book-appointment pt-5 pb-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="main-headind d-flex align-items-center 	gap-3 mb-3">
                  <div className="edit-btn back">
                    <Link to="/personal-info">
                      <div className="nav-anchor">
                        <i className="fa-solid fa-arrow-left"></i>
                      </div>
                    </Link>
                  </div>
                  <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
                    Back
                  </h5>
                </div>
                <div className="calender-main">
                  <div className="calendar-container">
                    <div className="calendar-header">
                      <span className="main-heading-font dark-color level-5 text-start ">
                        Select Date
                      </span>
                    </div>
                    <Calendar
                      onChange={onChange}
                      value={date}
                      view="month"
                      minDetail="month"
                      nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                      prevLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                      next2Label={null}
                      prev2Label={null}
                      minDate={new Date()}
                    />
                  </div>
               
                </div>
              </div>

              {/* <div className="col-lg-1"></div> */}
              <div className="col-lg-6 pe-5">
                <h3 className="main-heading-font dark-color level-3 text-start mb-4">
                  Select Hour
                </h3>
                <form>
                  <div className="row v_scroll">
                    {timeslots?.map((hour, index) => (
                      <div className="col-lg-6 mt-3" key={index}>
                        <div
                          className={`select-hour-bg ${
                            hour.status ? "active" : "inactive"
                          }`}
                          onClick={() => {
                            if (hour?.active !== "false") {
                              handleHourClick(hour?.slot);
                            }
                          }}
                        >
                          <h4
                            className={`${
                              selectedHour === hour?.slot
                                ? "selected-border"
                                : ""
                            }`}
                          >
                            {hour?.slot}
                          </h4>
                        </div>
                      </div>
                    ))}

                    <div>
                      {myday && date.toString() ? (
                        <>
                          <div
                            className={`select-hour-bg  ${
                              date ? "active mt-3" : ""
                            }`}
                          >
                            <h4>
                              {myday}&nbsp;
                              {date.toString()}
                            </h4>
                          </div>
                        </>
                      ) : (
                        <div
                          className={`select-hour-bg mt-3  ${
                            date ? "active mt-3" : ""
                          }`}
                        >
                          <h4>
                            <span className="select_date_arrow">
                              {" "}
                              <i className="fa-solid fa-arrow-left"></i>
                            </span>{" "}
                            &nbsp; Select Your Date{" "}
                          </h4>
                        </div>
                      )}
                    </div>
                    {/* <Timecheck /> */}
                  </div>
                </form>
              </div>

              <div className="row text-center">
                <div className="col-lg-12">
                  <Link className="btn w-50 wrapper-btn-main log-in mt-3 level-7 primary-regular-font text-decoration- mt-2">
                    <span
                      onClick={(e) => checkAvailiabity(e)}
                      className="loading-btn loading bg-wrapper w-100"
                    >
                      {loading ? (
                        <i className="fa fa-spinner"></i>
                      ) : (
                        " Check Physician Availiablity"
                      )}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : null}

      {/* ======================== */}

      {checkStatuspage == "true" ? (
        <section className="payment-module">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="physician_detail mb-4">
                  <div className="row">
                    <h3
                      style={{
                        textDecoration: "underlined",
                      }}
                      className="main-heading-font dark-color level-3 text-start mb-4"
                    >
                      Physician
                    </h3>
                    <div className="col-md-6">
                      <div className="physician_detail_dv">
                        <p>
                          <label className="main-heading-font dark-color ">
                            First Name:
                          </label>{" "}
                          &nbsp;
                          {physicianDetail?.first_name}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="physician_detail_dv">
                        <p>
                          {" "}
                          <label className="main-heading-font dark-color">
                            Last Name:
                          </label>{" "}
                          &nbsp;
                          {physicianDetail?.last_name}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="physician_detail_dv">
                        <p>
                          <label className="main-heading-font dark-color ">
                            Degree:
                          </label>{" "}
                          &nbsp;
                          {physicianDetail?.degree_title}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <h3 className="main-heading-font dark-color level-3 text-start">
                  Selected Time And Date
                </h3>
                <form>
                  <div className="row">
                 
                    <div>
                      {/* Time input */}

                      {/* Display the selected time */}
                      {selectedHour ? (
                        <div
                          className={`select-hour-bg   ${
                            selectedHour ? "active mt-3" : ""
                          }`}
                        >
                          <h4>{selectedHour}</h4>
                        </div>
                      ) : (
                        <div
                          className={`select-hour-bg mt-3  ${
                            selectedHour ? "active mt-3" : ""
                          }`}
                        >
                          <h4>Select Hour</h4>
                        </div>
                      )}
                      {myday && date.toString() ? (
                        <>
                          <div
                            className={`select-hour-bg  ${
                              date ? "active mt-3" : ""
                            }`}
                          >
                            <h4>
                              {myday}&nbsp;
                              {date.toString()}
                            </h4>
                          </div>
                        </>
                      ) : (
                        <div
                          className={`select-hour-bg mt-3  ${
                            date ? "active mt-3" : ""
                          }`}
                        >
                          <h4> Select you date </h4>
                        </div>
                      )}
                    </div>
                    {/* <Timecheck /> */}
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <Toggle
                        heading="Share Medical Reports"
                        initialState
                        isOn={isOn}
                        setIsOn={setIsOn}
                        containerClassName="symptoms-container d-flex align-items-center justify-content-between mt-3 border-bottom mb-2 pb-3"
                      />
                    </div>{" "}
                  </div>
                  <div className="row  mt-3">
                    <div className="form-group col-lg-12">
                      
                      <div className="custom-select-wrapper">
                        <h5 className="main-heading-font dark-color level-6 mb-2">
                          Enter Details
                        </h5>
                     
                        <Select
                          isMulti
                          name="specializations"
                          isSearchable={false}
                          options={formattedOptions} 
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={handleSelectChange}
                          value={formattedOptions.filter((option) =>
                            selectedSymptoms.includes(option.value)
                          )} 
                          placeholder="Area of Specialization"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-lg-12">
                      <h5 className="main-heading-font dark-color level-6 mb-2">
                        Enter Details
                      </h5>
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          id="message"
                          rows="4"
                          value={selectdetails}
                          onChange={(e) => setSelectdetails(e.target.value)}
                          placeholder="Enter Details"
                        />
                        <p className="forms-error">
                          {formErrors?.selectdetails}
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-lg-6">
                <div className="mainpaymnet">
                  <h5 className=" main-heading-font">Choose Card</h5>
                  <div className="d-flex align-items-start justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                      <img
                        src={visapayment}
                        className={`img-fluid payment-card ${
                          selectedCard === "visa" ? "selected" : ""
                        }`}
                        alt="Visa"
                        onClick={() => handleCardClick("visa")}
                      />
                      <img
                        src={mastercard}
                        className={`img-fluid payment-card ${
                          selectedCard === "mastercard" ? "selected" : ""
                        }`}
                        alt="Mastercard"
                        onClick={() => handleCardClick("mastercard")}
                      />
                    </div>
                    <div className="payment-wrapper">
                      <h4 className="level-7 text-end">Total Amount</h4>
                      <h3 className="main-heading-font level-3 text-end">
                        ${sitesetting?.appointment_charges}.00
                      </h3>
                    </div>
                  </div>
                  <form action="" className="payment-form">
                   
                    <div className="row mt-3">
                      <div className="col-lg-12">
                      
                        <StripeForm
                          styling={styling}
                          paynow="Book Appointment"
                          PaymentHandler={PlaceholderHandler}
                        />
                      </div>
                    </div>
                  </form>
                  <div className="row">
                    <div className="col-lg-12">
                      <MyModal show={show} handleClose={handleClose} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : null}

      {/* ================ */}
      <Footer />
    </>
  );
};

export default BookAppointment;
